import { render, staticRenderFns } from "./HeaderChecklist.vue?vue&type=template&id=37989d70&scoped=true"
import script from "./HeaderChecklist.vue?vue&type=script&lang=js"
export * from "./HeaderChecklist.vue?vue&type=script&lang=js"
import style0 from "./HeaderChecklist.vue?vue&type=style&index=0&id=37989d70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37989d70",
  null
  
)

export default component.exports